module.exports = __webpack_public_path__ + "static/media/synth-bonk.c8e39946.webm";